import type { DispatchViewDefinition } from "@storyboard/dispatch-view/view";

/** The `?view=` query parameter naming the active Dispatch view. */
export const VIEW_QUERY_PARAM = "view";

/**
 * Picks the active view from the compiled `web.dispatch` views: `?view=` when it names a known view, else the
 * configured default, else the first view in the cascade.
 */
export function resolveActiveView(
  views: Record<string, DispatchViewDefinition>,
  defaultViewId: string,
  requestedId: string | null,
): DispatchViewDefinition | null {
  if (requestedId && views[requestedId]) return views[requestedId];
  if (views[defaultViewId]) return views[defaultViewId];
  return Object.values(views)[0] ?? null;
}
